<template>
  <picture :class="aspect">
    <template v-if="picture">
      <template v-for="img in sourceImages">
        <source :srcset="img.src" :media="img.mediaQuery" :key="img.key|imageKey" />
      </template>
      <img :src="defaultSize" :width="defaultSize.width" :height="defaultSize.height" />
    </template>
    <template v-if="!picture">
      <img :src="imgset.src" :width="imgset.width" :height="imgset.height" />
    </template>
  </picture>
</template>
<script type="text/javascript">
export default {
  name: "VuePicture",
  props: {
    imgset: {
      type: Object,
      required: true,
      default: null
    },
    sizes: {
      type: Array,
      default: null
    },
    aspect: {
      type: String
    }
  },
  computed: {
    sourceImages() {
      let items = [];
      if (this.hasImageSizes && this.sizes.length > 1) {
        items = this.sizes
          .map(s => {
            const key = s.size.toString();
            let item = { src: "" };
            if (this.imgset.sizes.hasOwnProperty(key)) {
              let img = this.imgset.sizes[key];
              item.src = img.src;
              item.key = key;
              item.mediaQuery = this.toMediaQuery(s);
            }
            return item;
          })
          .filter(item => {
            let valid = false;
            if (item.src) {
              valid = item.src.length > 4;
            }
            return valid;
          });
      }
      return items;
    },
    defaultSize() {
      const key = "medium_" + this.aspect;
      let src = "";
      if (this.imgset.sizes.hasOwnProperty(key)) {
        src = this.imgset.sizes[key].src;
      }
      return src;
    },
    hasImageSizes() {
      if (this.imgset.sizes) {
        return this.imgset.sizes instanceof Object;
      } else {
        return false;
      }
    },
    src() {
      let src = "";
      if (this.imgset.src) {
        src = this.imgset.src;
      } else if (this.imgset.url) {
        src = this.imgset.url;
      }
      return src;
    },
    picture() {
      const ext = this.src
        .split(".")
        .pop()
        .toLowerCase();
      return (
        ["jpg", "jpeg", "png", "webp"].indexOf(ext) >= 0 && this.hasImageSizes
      );
    }
  },
  filters: {
    imageKey(val) {
      return "image-" + val;
    }
  },
  methods: {
    toMediaQuery(size) {
      let parts = [];
      if (size) {
        if (size.minWidth) {
          parts.push("min-width: " + size.minWidth + "px");
        }
        if (size.maxWidth) {
          parts.push("max-width: " + size.maxWidth + "px");
        }
      }
      return "(" + parts.join(") and (") + ")";
    }
  }
};
</script>
